import React, { useState, useEffect } from 'react'
import { Wrapper, TextField, Card } from '../../_components'
import Theme from '../../Theme'
import Axios from 'axios'

export default function ViewProductionForm() {
  
  const [ loading, setLoading ] = useState( true )
  const [ items, setItems ] = useState( null )

  useEffect( () => {
    if( loading ) {
        fetchProductionData()
    }
  }, [ loading ])

  const checkSeason = () => {
    switch( localStorage.getItem( "season" )?.toLowerCase() ) {
        case "season1":
            return { sNo: 1, label: "NovApril23" };
        case "season2":
            return { sNo: 2, label: "MaySept23" };
        default:
            return null
    }
  }

  const fetchProductionData = async () => {
    let season = await checkSeason()
    if( season?.sNo ){
        try {
            const response = await Axios.get( `https://mis.nec.go.ug/api/auth/fiefoc_production/${localStorage.getItem( "selectedFarmerCode" )}/${season?.label}` )
            if( response.data ){
                const { items, production } = response.data;
                let costItems = items.filter( val => val.parentID === production[ 0 ].id )
                setItems( {
                    products: costItems,
                    production
                })
                setLoading( false )
            }
        } catch (error) {
            setLoading( false )
            alert( "Server error occured. try again later." )
        }
    }
    
  }


  if( !items ) {
    return <div>Loading</div>
  }

  console.log( items );

  return (
    <Wrapper>
        <Card icon={Theme.PlusIcon} title="View Farmer Production Data">
            <div className="grid grid-cols-3 gap-1 items-center">
                {[ 
                    { id: 1, label: "Season", value: items.production[ 0 ].season },
                    { id: 1, label: "Farmer Name", value: items.production[ 0 ].farmer_name } ,
                    { id: 1, label: "Farmer Code", value: items.production[ 0 ].farmer_code } ,
                    { id: 1, label: "Block No", value: items.production[ 0 ].block } 
                ].map( ( item, idx ) => { 
                    return (
                        <TextField 
                            label={item.label}
                            value={item.value}
                        />
                    )
                } )}
            </div>


            {/* <div className="grid grid-cols-3 gap-1 items-center">
                {items.products.map( ( val, idx ) => { 
                    return (
                        
                    )
                } )}
            </div> */}
        </Card>
    </Wrapper> 
  )
}
